import {useTranslation} from 'react-i18next';
import infoIcon from 'assets/icons/info.svg?no-inline';
import {StyledPreAuthorization3DSInfoModal} from './styled';

type ProcessingModalProps = {
  isOpen: boolean;
};

const IconProps = {width: 56, height: 56};

function ModalContent() {
  const {t} = useTranslation();
  return (
    <div>
      {t('authorize_transaction')}
      <br /> <br />
      <strong>{t('you_may_see_0_amount')}</strong>
      <br /> <br />
      {t('mey_be_charged')}
    </div>
  );
}

function PreAuthorization3DSInfoModal({isOpen}: ProcessingModalProps) {
  const {t} = useTranslation();
  return (
    <StyledPreAuthorization3DSInfoModal
      open={isOpen}
      title={t('payment_authorization')}
      text={ModalContent()}
      iconSrc={infoIcon}
      iconAlt="info"
      iconProps={IconProps}
    ></StyledPreAuthorization3DSInfoModal>
  );
}

export default PreAuthorization3DSInfoModal;
